// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.items-manager {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.manager-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.manager-header h1 {
  font-size: 32px;
}

.item-form {
  padding: 24px;
}

.item-form h2 {
  font-size: 24px;
  margin-bottom: 24px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-dark);
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid var(--border);
  border-radius: 8px;
  font-size: 16px;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: auto;
  cursor: pointer;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.item-card-admin {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  gap: 24px;
  padding: 20px;
}

.item-images-admin {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.item-image-wrapper {
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
}

.item-image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-image-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0.9);
  color: var(--error);
  border-radius: 50%;
  font-size: 18px;
  line-height: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.item-image-wrapper:hover .delete-image-btn {
  opacity: 1;
}

.upload-image-btn {
  width: 90px;
  height: 90px;
  border: 2px dashed var(--border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-light);
  font-size: 12px;
  transition: all 0.3s ease;
}

.upload-image-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.item-info-admin h3 {
  font-size: 20px;
  margin-bottom: 4px;
}

.item-info-admin .category {
  color: var(--text-light);
  font-size: 14px;
  margin-bottom: 8px;
}

.item-info-admin .price {
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 12px;
}

.item-info-admin .description {
  color: var(--text-dark);
  margin-bottom: 12px;
  line-height: 1.5;
}

.item-meta {
  display: flex;
  gap: 16px;
  font-size: 14px;
}

.item-meta .available {
  color: var(--success);
  font-weight: 600;
}

.item-meta .unavailable {
  color: var(--error);
  font-weight: 600;
}

.item-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.delete-btn {
  color: var(--error);
  border-color: var(--error);
}

.delete-btn:hover {
  background-color: var(--error);
  color: white;
}

@media (max-width: 768px) {
  .item-card-admin {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/ItemsManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".items-manager {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.manager-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.manager-header h1 {\n  font-size: 32px;\n}\n\n.item-form {\n  padding: 24px;\n}\n\n.item-form h2 {\n  font-size: 24px;\n  margin-bottom: 24px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid var(--border);\n  border-radius: 8px;\n  font-size: 16px;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: auto;\n  cursor: pointer;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.item-card-admin {\n  display: grid;\n  grid-template-columns: 200px 1fr auto;\n  gap: 24px;\n  padding: 20px;\n}\n\n.item-images-admin {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.item-image-wrapper {\n  position: relative;\n  width: 90px;\n  height: 90px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.item-image-wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.delete-image-btn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 24px;\n  height: 24px;\n  background-color: rgba(255, 255, 255, 0.9);\n  color: var(--error);\n  border-radius: 50%;\n  font-size: 18px;\n  line-height: 1;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.item-image-wrapper:hover .delete-image-btn {\n  opacity: 1;\n}\n\n.upload-image-btn {\n  width: 90px;\n  height: 90px;\n  border: 2px dashed var(--border);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-light);\n  font-size: 12px;\n  transition: all 0.3s ease;\n}\n\n.upload-image-btn:hover {\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.item-info-admin h3 {\n  font-size: 20px;\n  margin-bottom: 4px;\n}\n\n.item-info-admin .category {\n  color: var(--text-light);\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n\n.item-info-admin .price {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--primary-color);\n  margin-bottom: 12px;\n}\n\n.item-info-admin .description {\n  color: var(--text-dark);\n  margin-bottom: 12px;\n  line-height: 1.5;\n}\n\n.item-meta {\n  display: flex;\n  gap: 16px;\n  font-size: 14px;\n}\n\n.item-meta .available {\n  color: var(--success);\n  font-weight: 600;\n}\n\n.item-meta .unavailable {\n  color: var(--error);\n  font-weight: 600;\n}\n\n.item-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.delete-btn {\n  color: var(--error);\n  border-color: var(--error);\n}\n\n.delete-btn:hover {\n  background-color: var(--error);\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .item-card-admin {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
